module.exports = __webpack_public_path__ + "static/media/logo-contigo-color.a97790a3.png";